<app-info-box [infoText]="infoText()">
  <label [attr.for]="forId() ?? null" [title]="caption()">{{caption()}}</label>
  @if (isRequired && isEnabled) {
    <span class="required">*</span>
  }
</app-info-box>
